import React from 'react';

import './Form.module.css';

const TextArea = ({ onChange, value, ...props }) => {
  return (
    <textarea
      styleName="textarea"
      defaultValue={value || ''}
      onBlur={onChange}
      {...props}
    />
  );
};

export default TextArea;
